(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Spinner", [], factory);
	else if(typeof exports === 'object')
		exports["Spinner"] = factory();
	else
		root["Spinner"] = factory();
})(window, function() {
return 